const projectData = [
    {
        id: 1,
        name: "My Portfolio",
        description: "A portfolio website made with React.Js for presenting myself and my work in an organised and decorated way to the world.",
        tech: ["React", "Tailwind", "CSS", "Firebase", "Firebase"],
        links: [
            {
                link: "https://rushi-web.vercel.app",
                name: "Live",
                icon: "fa-solid fa-globe"
            }
        ]
    },
    {
        id: 6,
        name: "Sortly",
        description: "This is a new generation inventory and stock management website. It is made for retailers and shopkeepers to keep track of their sales digitally at a high extent which can improve their performance.",
        tech: ["React", "NodeJS", "JWT", "ExpressJS", "MongoDB"],
        links: [
            {
                link: "https://sortly.vercel.app/",
                name: "Live",
                icon: "fa-solid fa-globe"
            },
            {
                link: "https://github.com/Rushi0508/sortly",
                name: "Github",
                icon: "fa-brands fa-github"
            }
        ]
    },
    {
        id: 2,
        name: "CampersClub",
        description: "CampersClub is a website where users can create and review campgrounds. In order to review or create a campground, you must be authenticated.",
        tech: ["Bootstrap", "ExpressJS", "NodeJS", "MongoDB"],
        links: [
            {
                link: "https://campers-club.vercel.app/",
                name: "Live",
                icon: "fa-solid fa-globe"
            },
            {
                link: "https://github.com/Rushi0508/CampersClub",
                name: "Github",
                icon: "fa-brands fa-github"
            },
            {
                link: "https://www.youtube.com/watch?v=wcNEjUpNiLc",
                name: "Youtube",
                icon: "fa-brands fa-youtube"
            }
        ]
    },
    {
        id: 4,
        name: "SocialBuzz",
        description: "SocialBuzz a platform developed to connect people around. It allows users to create profiles, follow each other, share photos, and engage in discussions with other users.",
        tech: ["HTML", "Python", "Django", "Bootstrap"],
        links: [
            {
                link: "https://github.com/Rushi0508/SocialBuzz",
                name: "Github",
                icon: "fa-brands fa-github"
            },
            {
                link: "https://www.youtube.com/watch?v=0pzbbO11bhc",
                name: "Youtube",
                icon: "fa-brands fa-youtube"
            }

        ]
    },
    {
        id: 3,
        name: "GetThatDoc",
        description: "GetThatDoc is a notes sharing web app, where students can download, search, upload notes and see upload details.",
        tech: ["CSS", "PHP", "MySQL", "Javascript"],
        links: [
            {
                link: "http://getthatdoc.epizy.com/",
                name: "Live",
                icon: "fa-solid fa-globe"
            },
            {
                link: "https://github.com/Rushi0508/GetThatDoc",
                name: "Github",
                icon: "fa-brands fa-github"
            },
            {
                link: "https://www.youtube.com/watch?v=ORObyqzjVYw",
                name: "Youtube",
                icon: "fa-brands fa-youtube"
            }
        ]
    },
    {
        id: 5,
        name: "MyFoodKart",
        description: "MyFoodKArt is a full stack food ordering website, where user can browse, add to cart, remove and order the food items.",
        tech: ["HTML", "CSS", "Javascript", "AJAX", "PHP", "MySQL"],
        links: [
            {
                link: "http://myfoodkart.epizy.com/",
                name: "Live",
                icon: "fa-solid fa-globe"
            },
            {
                link: "https://github.com/Rushi0508/MyFoodKart",
                name: "Github",
                icon: "fa-brands fa-github"
            },
            {
                link: "https://www.youtube.com/watch?v=l1FES06VhIE",
                name: "Youtube",
                icon: "fa-brands fa-youtube"
            }
        ]
    },

]

export default projectData